import React, { useState, useEffect } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { menuTypeItems } from '../../helpers/utils';
import { useMenuTypeState, useMenuTypeDispatch } from '../../context/MenuTypeContext';
import './menu-types.css';
const MenuTypes = ({
    defaultMenuTypeItem
}) => {
    const { selectedMenuType, loadingState } = useMenuTypeState();
    const dispatch = useMenuTypeDispatch();
    const selectedItem = ((selectedMenuType || {}).text || defaultMenuTypeItem || menuTypeItems.LUNCH.text);
    useEffect(() => {
        setDefaultMenuItem();
    }, [])
    const setDefaultMenuItem = async () => {
        if (!(selectedMenuType || {}).text) {
            await dispatch({ type: 'SET_MENUTYPE', payload: (menuTypeItems.LUNCH) });
        }
    }
    return (
        <Nav tabs className='d-flex justify-content-end'>
            {
                Object.keys(menuTypeItems).map((type, i) => (
                    <NavItem key={i}>
                        <NavLink
                            className={selectedItem === menuTypeItems[type].text ? "active" : ""}
                            onClick={() => {
                                dispatch({ type: 'SET_MENUTYPE', payload: menuTypeItems[type] });
                                //dispatch({ type: 'SET_LOADING', payload: true });
                                //console.log("selectedMenuType::::",selectedMenuType);
                                //console.log("LoadingState:::::",loadingState);
                            }}
                            disabled={loadingState}
                        ><img className='menu-type-img' src={menuTypeItems[type].image} width={'23px'} /> {menuTypeItems[type].text}
                        </NavLink>
                    </NavItem>

                ))
            }
        </Nav>
    )
}
export default MenuTypes